<div class="mobile-ticket-container" *ngIf="ventaDetalles">
  <header class="mobile-ticket-header">
    <div class="ticket-meta">
      <h2>Ticket</h2>
      <span class="ticket-id">#{{ ventaDetalles.id | ticketNumber }}</span>
    </div>
    <div class="ticket-actions">
      <button mat-icon-button color="primary" (click)="exportarPdf()" aria-label="Exportar PDF">
        <mat-icon>picture_as_pdf</mat-icon>
      </button>
      <button mat-icon-button color="primary" (click)="imprimirTicket()" aria-label="Imprimir">
        <mat-icon>print</mat-icon>
      </button>
    </div>
  </header>

  <section class="ticket-section info">
    <div class="info-block">
      <label>Fecha</label>
      <span>{{ ventaDetalles.createdAt | date:'medium' }}</span>
    </div>
    <div class="info-block">
      <label>Estado</label>
      <mat-chip [color]="getEstadoColor(ventaDetalles.estado)" selected>{{ ventaDetalles.estado | titlecase }}</mat-chip>
    </div>
    <div class="info-block">
      <label>Vendedor</label>
      <span>{{ vendedorNombre || 'N/D' }}</span>
    </div>
  </section>

  <section class="ticket-section productos">
    <h3>Productos</h3>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let detalle of ventaDetalles.detalles">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ detalle.producto?.nombre }}
          </mat-panel-title>
          <mat-panel-description>
            {{ detalle.subtotal | currency }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="producto-grid">
          <div>
            <label>Código</label>
            <span>{{ detalle.producto?.codigo }}</span>
          </div>
          <div>
            <label>Proveedor</label>
            <span>{{ detalle.producto?.proveedorNombre || 'Sin proveedor' }}</span>
          </div>
          <div>
            <label>Cantidad</label>
            <span>{{ detalle.cantidad }}</span>
          </div>
          <div>
            <label>P. Unitario</label>
            <span>{{ detalle.precioUnitario | currency }}</span>
          </div>
          <div class="descripcion">
            <label>Descripción</label>
            <span>{{ detalle.producto?.descripcion || 'Sin descripción' }}</span>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </section>

  <section class="ticket-section resumen">
    <h3>Resumen</h3>
    <div class="resumen-row">
      <span>Subtotal</span>
      <strong>{{ ventaDetalles.total - ventaDetalles.impuesto | currency }}</strong>
    </div>
    <div class="resumen-row">
      <span>Impuesto</span>
      <strong>{{ ventaDetalles.impuesto | currency }}</strong>
    </div>
    <div class="resumen-row total">
      <span>Total</span>
      <strong>{{ ventaDetalles.total | currency }}</strong>
    </div>
    <div class="resumen-row">
      <span>Recibido</span>
      <strong>{{ ventaDetalles.dineroRecibido | currency }}</strong>
    </div>
    <div class="resumen-row">
      <span>Cambio</span>
      <strong>{{ ventaDetalles.cambio | currency }}</strong>
    </div>
  </section>

  <!-- Sección de Abonos (para ventas con abonos: pendientes o completadas) -->
  <section *ngIf="mostrarSeccionAbonos()" class="ticket-section abonos">
    <div class="abonos-header-mobile">
      <h3>Historial de Pagos</h3>
      <button 
        *ngIf="ventaDetalles.estado === 'pendiente'"
        mat-raised-button 
        color="primary" 
        (click)="toggleFormularioAbono()"
        [disabled]="!puedeAgregarAbono() || isLoading"
        class="add-abono-btn-mobile">
        <mat-icon>{{ mostrarFormularioAbono ? 'close' : 'add' }}</mat-icon>
        {{ mostrarFormularioAbono ? 'Cancelar' : 'Agregar' }}
      </button>
    </div>

    <!-- Resumen de pagos -->
    <div class="payment-summary-mobile">
      <div class="summary-item-mobile">
        <span>Total Venta:</span>
        <strong>{{ ventaDetalles.total | currency }}</strong>
      </div>
      <div class="summary-item-mobile">
        <span>Total Pagado:</span>
        <strong class="success">{{ totalPagado | currency }}</strong>
      </div>
      <div class="summary-item-mobile">
        <span>Saldo Pendiente:</span>
        <strong [class.warning]="saldoPendiente > 0" [class.success]="saldoPendiente <= 0">
          {{ saldoPendiente | currency }}
        </strong>
      </div>
    </div>

    <!-- Formulario para agregar abono (solo para ventas pendientes) -->
    <div *ngIf="ventaDetalles.estado === 'pendiente' && mostrarFormularioAbono && puedeAgregarAbono()" class="abono-form-mobile">
      <form [formGroup]="abonoForm" (ngSubmit)="registrarAbono()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Monto del Abono</mat-label>
          <input matInput type="number" formControlName="monto" min="0.01" [max]="saldoPendiente" step="0.01">
          <span matPrefix>$&nbsp;</span>
          <mat-hint>Máximo: {{ saldoPendiente | currency }}</mat-hint>
          <mat-error *ngIf="abonoForm.get('monto')?.hasError('required')">
            El monto es requerido
          </mat-error>
          <mat-error *ngIf="abonoForm.get('monto')?.hasError('min')">
            El monto debe ser mayor a cero
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Método de Pago</mat-label>
          <mat-select formControlName="metodoPago">
            <mat-option *ngFor="let m of metodosPago" [value]="m">
              {{ metodoPagoLabels[m] }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" type="submit" class="full-width" [disabled]="abonoForm.invalid || isLoading">
          <mat-icon>payment</mat-icon>
          Registrar Abono
        </button>
      </form>
    </div>

    <!-- Lista de abonos (ordenados por fecha) -->
    <div *ngIf="pagos.length > 0" class="abonos-list-mobile">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let pago of pagos; let i = index">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="pago-index">#{{ pagos.length - i }}</span>
              <span class="pago-fecha">{{ pago.createdAt | date:'short' }}</span>
            </mat-panel-title>
            <mat-panel-description>
              <strong>{{ pago.monto | currency }}</strong>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="pago-detail-mobile">
            <div><label>Fecha y Hora:</label> <span>{{ pago.createdAt | date:'medium' }}</span></div>
            <div><label>Método:</label> <span>{{ metodoPagoLabels[pago.metodoPago] || pago.metodoPago || '—' }}</span></div>
            <div><label>Monto:</label> <strong class="monto-pago">{{ pago.monto | currency }}</strong></div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div *ngIf="pagos.length === 0 && ventaDetalles.estado === 'pendiente' && !mostrarFormularioAbono" class="no-abonos-mobile">
      <mat-icon>info</mat-icon>
      <p>No hay pagos registrados aún</p>
    </div>
  </section>
</div>

<div class="mobile-actions">
  <button mat-stroked-button color="primary" (click)="exportarPdf()">
    <mat-icon>picture_as_pdf</mat-icon>
    PDF
  </button>
  <button mat-flat-button color="primary" (click)="imprimirTicket()">
    <mat-icon>print</mat-icon>
    Imprimir
  </button>
  <button mat-button (click)="onCancel()">
    Cerrar
  </button>
</div>

